module.exports = __webpack_public_path__ + "static/img/ding41.91f3240.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ding41.png
// module id = +1ja
// module chunks = 0